import _ from 'lodash';
import { createActionFactory } from '../../common/redux';
const { createAction, createApiFailureAction } = createActionFactory('Experience Workspace => displayUnit => ');

const add = createAction(
  'add display unit',
  displayUnits => (_.isArray(displayUnits) ? { displayUnits } : { displayUnits: [displayUnits] })
);

const fetch = createAction('fetch display units');
const fetchFailure = createApiFailureAction('fetch display units failure');
const fetchSuccess = createAction('fetch display units success', displayUnits => ({ displayUnits }));

const removeDisplayUnit = createAction('remove display unit', id => ({ id }));

const updateDisplayUnitSuccess = createAction('update display unit success', displayUnit => ({ displayUnit }));

export default {
  add,

  fetch,
  fetchFailure,
  fetchSuccess,

  removeDisplayUnit,

  updateDisplayUnitSuccess,
};
